'use strict';

var _a;

Object.defineProperty(exports, '__esModule', {
  value: true,
});

exports.buttonSizeMap = void 0;

var components_1 = require('../../../constants/components');

exports.buttonSizeMap =
  ((_a = {}),
  (_a[components_1.SIZES.small] = components_1.TYPOGRAPHY_VARIANTS.accentS),
  (_a[components_1.SIZES.medium] = components_1.TYPOGRAPHY_VARIANTS.accentM),
  (_a[components_1.SIZES.large] = components_1.TYPOGRAPHY_VARIANTS.accentM),
  _a);
